export function subtract(a: number | undefined, b: number | undefined): number | undefined {
    return a == null || b == null ? undefined : a - b;
}

export function average(a: number | undefined, b: number | undefined): number | undefined {
    return a == null || b == null ? undefined : (a + b) / 2;
}
